import { queryDownloadFile } from '../common/pageable/query-download-file';
import { EtablissementFichierType } from '../etablissement-fichier';
import { servicesApi } from '../services';

const ORGANISMES_ETABLISSEMENTS_FICHIERS_URL_PREFIX = (id: number, etablissementId: number) => `organismes/${id}/etablissements/${etablissementId}/fichiers`;

const organismeEtablissementApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    // On utilise une mutation ici malgré le GET, pour empêcher la mise en cache
    downloadOrganismeEtablissementGeneratedDeclaration: build.mutation<void, DownloadOrganismeEtablissementGeneratedDeclarationMutationArgs, any>({
      queryFn: ({ id, etablissementId, travail }, api, extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${ORGANISMES_ETABLISSEMENTS_FICHIERS_URL_PREFIX(id, etablissementId)}/generate/declaration`,
        params: { travail },
        defaultFilename: 'Déclaration',
      }),
      invalidatesTags: ['Etablissements', 'EtablissementFichiers'],
    }),

    downloadOrganismeEtablissementFichier: build.mutation<void, DownloadOrganismeEtablissementFichierMutationArgs, any>({
      queryFn: ({
                  id,
                  etablissementId,
                  fichierType,
                  defaultFilename,
                  forceDefaultFilename,
                }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${ORGANISMES_ETABLISSEMENTS_FICHIERS_URL_PREFIX(id, etablissementId)}/${fichierType}/resource`,
        defaultFilename,
        forceDefaultFilename,
      }),
    }),

    depositOrganismeEtablissementFichier: build.mutation<void, DepositOrganismeEtablissementFichierMutationArgs, any>({
      query: ({ id, etablissementId, fichierType, formData }) => ({
        url: `${ORGANISMES_ETABLISSEMENTS_FICHIERS_URL_PREFIX(id, etablissementId)}/${fichierType}`,
        method: 'PUT',
        body: formData,
        meta: { skipErrorToast: true },
      }),
      invalidatesTags: ['Etablissements', 'EtablissementFichiers'],
    }),
  }),
});

interface DownloadOrganismeEtablissementGeneratedDeclarationMutationArgs {
  id: number;
  etablissementId: number;
  travail?: boolean;
}

interface DownloadOrganismeEtablissementFichierMutationArgs {
  id: number;
  etablissementId: number;
  fichierType: EtablissementFichierType;
  defaultFilename?: string;
  forceDefaultFilename?: boolean;
}

interface DepositOrganismeEtablissementFichierMutationArgs {
  id: number;
  etablissementId: number;
  fichierType: EtablissementFichierType;
  formData: FormData; // fichier: File
}

export const {
  useDownloadOrganismeEtablissementGeneratedDeclarationMutation,
  useDownloadOrganismeEtablissementFichierMutation,
  useDepositOrganismeEtablissementFichierMutation,
} = organismeEtablissementApi;